module.exports = __webpack_public_path__ + "static/media/utensils.80b07601.svg";